export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";